import * as React from 'react'
import Box from '@mui/material/Box'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TablePagination from '@mui/material/TablePagination'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import IconButton from '@mui/material/IconButton'
import {
  Button, Chip, Container, Dialog, DialogContent, Drawer, InputBase,
  Link, Stack, Switch, TableHead, TableSortLabel, Tooltip, Typography
}
  from '@mui/material';
import SearchIcon from '@mui/icons-material/Search'
import AddNewDoc from './addNewDoc'
import ViewDoc from './viewDoc'
import { useEffect, useState } from 'react'
import jwt_decode from 'jwt-decode'
import SkeletonTableLoader from '../../../common/components/loaders/skeletonLoader'
import { useLocation, useSearchParams } from 'react-router-dom'
import LoadingSection from '../../../common/components/loaders/loader'
import NoDataFoundCard from '../../../common/components/cards/noDataFoundCard'
import { createRef } from 'react'
import {
  checkPermission,
  getCompanyLevel,
  getComparator,
  normalizeApiResponse,
  stableSort,
} from '../../../helpers/HelperFunctions'
import { PERMISSIONS } from '../../../helpers/Constants'
import { styled } from '@mui/system'
import { Add as AddIcon } from '@mui/icons-material';
import CancelIcon from '@mui/icons-material/Cancel'
import DrawerHeader from '../../../common/components/drawer/DrawerHeader'
import ThemeButton from '../../../common/components/button/Button'
import { useUserManagementRedux } from '../../userManagement/UserManagement'
import { useToastContext } from '../../../App'
import { useCommonRedux } from '../../../store/middlewares/CommonRedux'
import { deleteFileDoc, downloadFileDoc, getFilesByCompany } from '../../../api/orders/directRoutingAPI'
import { LoadingButton } from '@mui/lab'


import DeleteIcon from '@mui/icons-material/Delete';
import DownloadIcon from '@mui/icons-material/Download';
import GlobalSearch from '../../../common/components/tableFilter/GlobalSearch'
// import EditIcon from '@mui/icons-material/Edit';
import FilterListIcon from '@mui/icons-material/FilterList';
import ColumnFilter from '../../../common/components/tableFilter/ColumnFilter'
import useTableFilters from '../../../common/components/tableFilter/useTableFilters'

const tableColumns = [
  { key: 'FileName', label: 'File Name' },
  { key: 'Description', label: 'Description' },
]

const IOSSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}))

function DocTable(props) {
  const { state: commonState } = useCommonRedux();
  const { toast } = useToastContext();
  const [page, setPage] = React.useState(0)
  const [rowsPerPage, setRowsPerPage] = React.useState(5)
  const [rowsList, setRowsList] = React.useState([]);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false)
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isDeleteButtonLoading, setIsDeleteButtonLoading] = useState(false)

  const [edited, setEdited] = React.useState('')
  const [details, setDetails] = React.useState('')
  const [loader, setLoader] = React.useState(false)
  const [submitLoader, setSubmitLoader] = React.useState(false)
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - rowsList?.length)
      : 0
  const pageTopRef = createRef()
  const [order, setOrder] = React.useState('asc')
  const [orderBy, setOrderBy] = React.useState()
  const {
    searchTerm,
    setSearchTerm,
    filteredData,
    uniqueValues,
    filterAnchorEl,
    setFilterAnchorEl,
    currentColumn,
    openFilter,
    closeFilter,
    toggleFilter,
    clearColumnFilter,
    isFilterActive,
    filters,
  } = useTableFilters(rowsList, tableColumns);
  const currentLabel = tableColumns.find((c) => c.key === currentColumn)?.label || currentColumn || '';
  const sortedRows = React.useMemo(() => {
    return stableSort(filteredData, getComparator(order, orderBy));
  }, [filteredData, order, orderBy]);

  let inputHandler = (e) => { console.log('eeeee->', e); }


  const getUploadedDocs = (id, noPageLoad) => {
    if (!noPageLoad) setLoader(true);
    getFilesByCompany({ companyId: id }, { companyId: id, CustomerId: id }, id)
      .then((response) => {
        const records = response?.data?.result?.records || response?.data?.Result?.Records || []
        setRowsList(records)
        setLoader(false)
      })
      .catch((error) => {
        setLoader(false)
        toast.showToast(normalizeApiResponse(error)?.message, 'error')
      })
  }

  const getDecodeValue = () => {
    const decodeToken = localStorage.getItem('sd_cp.jwt:tkn')
    const decoded = jwt_decode(decodeToken)
    if (decoded) {
      let companyId = searchParams.get('company_id')
      if (!companyId) {
        companyId = decoded?.company_id
      }
      getUploadedDocs(companyId)
    }
  }
  const handleChangePage = (event, newPage) => {
    setPage(newPage)
    pageTopRef.current.scrollTop = 0
  }
  const gotoDrawer = (event) => {
    setEdited(event)
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value))
    setPage(0)
    pageTopRef.current.scrollTop = 0
  }

  const [state, setState] = React.useState({
    right: false,
  })

  const toggleDrawer = (anchor, open, switchVal, details, load) => {
    if (load) {
      getDecodeValue()
    }
    setDetails(details)
    setEdited(switchVal)
    setState({ ...state, [anchor]: open })
  }

  useEffect(() => {
    getDecodeValue()
  }, [])

  const checkAddEdit = (item, index) => {
    switch (item) {
      case 'add':
        return <AddNewDoc toggleDrawer={toggleDrawer} />
      case 'view':
        return (
          <>
            <ViewDoc details={details} gotoDrawer={gotoDrawer} download={downloadDocument}></ViewDoc>
          </>
        )

      case 'edit':
        return (
          <>
            <AddNewDoc toggleDrawer={toggleDrawer} details={selectedDoc} action='edit' />
          </>
        )
    }
  }

  const renderDrawerHeader = () => {
    if (edited == 'view') {
      return (
        <DrawerHeader
          header="File Details"
          onClick={() => toggleDrawer('right', false)}
        />
      )
    }
    if (edited == 'add') {
      return (
        <DrawerHeader
          header="Add Document"
          onClick={() => toggleDrawer('right', false)}
        />
      )
    }

    if (edited == 'edit') {
      return (
        <DrawerHeader
          header="Edit Document"
          onClick={() => toggleDrawer('right', false)}
        />
      )
    }
    return null
  }


  const downloadDocument = async (rowData) => {
    setSubmitLoader(true)
    const decodeToken = localStorage.getItem('sd_cp.jwt:tkn');
    const decoded = jwt_decode(decodeToken);

    const companyId = searchParams.get('company_id') || decoded?.company_id;

    try {
      const response = await downloadFileDoc({ companyId: companyId },
        { companyId: companyId, CustomerId: companyId }, companyId, rowData,
      );
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", rowData?.FileName || rowData?.fileName); // filename
        document.body.appendChild(link);
        link.click();

        link.remove();
        window.URL.revokeObjectURL(url);
        setSubmitLoader(false)
      }
    } catch (error) {
      toast.showToast(normalizeApiResponse(error)?.message, 'error');
    } finally {
      setSubmitLoader(false)
    }
  }

  const handleAction = (row, action) => {
    setSelectedDoc(row);
    if (action == 'delete') {
      setIsDeleteDialogOpen(true);
    }
    else if (action == 'download') {
      downloadDocument(row);
    }
    else if (action == 'edit') {
      setDetails(row);
      setEdited('edit');
      toggleDrawer('right', true, 'edit');
    }
  }

  const renderIconTooltip = (title, Icon, rowData, action) => (
    <Tooltip title={title}>
      <span className="icon-container">
        <Icon color="primary" onClick={() => handleAction(rowData, action)} />
      </span>
    </Tooltip>
  );


  const renderIcons = (row) => {
    return (
      <>
        {renderIconTooltip(
          `Download file`,
          DownloadIcon,
          row,
          'download'
        )}
      </>
    );
  };


  return (
    <Container maxWidth="xl">
      {submitLoader && <LoadingSection />}

      <React.Fragment>
        <Drawer
          PaperProps={{ sx: { width: '25%' } }}
          variant="persistent"
          hideBackdrop
          anchor="right"
          open={state['right']}
        >
          {/* {renderBackAndCloseButtons()} */}
          {renderDrawerHeader()}
          {checkAddEdit(edited)}
        </Drawer>
      </React.Fragment>

      {/* Search + Add Documents section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', my: 2 }}>
        <GlobalSearch
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
          placeholder="Search Roles"
        />

        <Tooltip title="Add Document">
          <ThemeButton
            text="Add Document"
            variant="contained"
            size="medium"
            sx={{ height: '32px', mt: 2 }}
            startIcon={<AddIcon />}
            onClick={() => toggleDrawer('right', true, 'add')}
          />
        </Tooltip>
      </Box>

      {/* Table Section */}
      <TableContainer
        sx={{
          height:
            rowsPerPage == 5 || rowsList?.length <= 7
              ? 'max-content'
              : 'calc(95vh - 200px)',
        }}
        component={Paper}
        ref={pageTopRef}
      >
        <Table stickyHeader sx={{ minWidth: 500 }} aria-label="custom pagination table">
          <TableHead className="thead">
            <TableRow>
              <TableCell width="10px">S.No.</TableCell>
              {tableColumns.map((col) => (
                <TableCell key={col.key}>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <TableSortLabel
                      active={orderBy === col.key}
                      direction={orderBy === col.key ? order : 'asc'}
                    // onClick={(e) => handleRequestSort(e, col.key)}
                    >{col.label}</TableSortLabel>
                    <IconButton
                      size="small"
                      onClick={(e) => openFilter(e, col.key)}
                      color={isFilterActive(col.key) ? 'primary' : 'default'}
                    >
                      <FilterListIcon fontSize="small" />
                    </IconButton>
                    {isFilterActive(col.key) && (
                      <Chip size="small"
                        label={(filters?.[col.key]?.length || 0)}
                        //  label={filters[col.key]?.length  || 0} 
                        color="primary" />
                    )}
                  </Box>
                </TableCell>
              ))}
              {/* <TableCell>File Name</TableCell>
              <TableCell>Description</TableCell> */}
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>


          <TableBody className="tbody">
            {
              loader ? (
                <TableRow style={{ height: 53 * emptyRows }}>
                  <TableCell colSpan={6}>
                    <SkeletonTableLoader />
                  </TableCell>
                </TableRow>
              )
                : (
                  <>
                    {(rowsPerPage > 0
                      ? filteredData?.slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      : filteredData
                    )?.map((row, index) => (
                      <TableRow key={row?.FileId}>
                        <TableCell>{page * rowsPerPage + (index + 1)}</TableCell>
                        <TableCell scope="row"
                        // onClick={() => toggleDrawer('right', true, 'view', row)}
                        >
                          <p>{row?.fileName}</p>
                        </TableCell>

                        <TableCell scope="row" >
                          <p>{row?.description}</p>
                        </TableCell>

                        <TableCell scope="row" >
                          {renderIcons(row)}
                        </TableCell>
                      </TableRow>
                    ))}

                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )}

                    {filteredData?.length === 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} style={{ border: 'none' }}>
                          <h3>
                            <NoDataFoundCard
                              messages="No Such Documents Found"
                              borderNone={true}
                            />
                          </h3>
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )
            }
          </TableBody>
        </Table>
      </TableContainer>
      <Stack direction="row" justifyContent="space-between">
        {!loader && (
          <Box sx={{ mt: 4, display: 'flex', justifyContent: 'flex-start', px: 2 }}>
            <Chip
              label={
                <>
                  <strong>{filteredData.length}</strong> / {rowsList.length} records
                </>
              }
              color={filteredData.length < rowsList.length ? 'primary' : 'default'}
              variant="outlined"
              size="small"
            />
            {(filters && Object.keys(filters).length > 0 || searchTerm.trim()) && (
              <Chip
                label="Filtered"
                color="secondary"
                size="small"
                sx={{ ml: 1 }}
              />
            )}
          </Box>
        )}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
          component="div"
          count={filteredData?.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Stack>
      <ColumnFilter
        anchorEl={filterAnchorEl}
        onClose={closeFilter}
        columnLabel={currentLabel}
        uniqueValues={uniqueValues[currentColumn] || []}
        selectedValues={filters ? filters[currentColumn] : []}
        onToggleValue={toggleFilter}
        onClear={clearColumnFilter}
      />

    </Container >
  )
}

export default DocTable
